/** Automation id for the "Add to <ticket system>" button. */
export const ADD_TO_TICKET_SYSTEM_BTN_ID = 'add-to-ticket-system-btn';
